import React from 'react';
import { cn } from './cn';

export const Label = ({ className, ...props }) => (
  <label className={cn('block mb-[7px] text-body-sm font-medium text-ink-body', className)} {...props} />
);

/**
 * Text input.
 *
 * Sizing note: the global base layer already forces 16px on real text fields
 * below `sm`, because anything smaller makes iOS zoom the page on focus. Don't
 * override the font size here.
 */
export const Input = React.forwardRef(function Input(
  { as: Tag = 'input', className, ...props },
  ref
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        'block w-full min-h-[var(--tap-target)] rounded-field px-3.5 py-2.5',
        'bg-surface-sunken border border-line text-ink placeholder:text-ink-subtle',
        'transition-[border-color,background-color] duration-[120ms]',
        'focus:outline-none focus:border-accent focus:bg-surface',
        'disabled:text-ink-disabled disabled:cursor-not-allowed',
        Tag === 'textarea' && 'min-h-[104px] leading-relaxed resize-y',
        className
      )}
      {...props}
    />
  );
});

export const Hint = ({ className, ...props }) => (
  <p className={cn('mt-[7px] text-caption text-ink-subtle', className)} {...props} />
);

export const FieldError = ({ className, ...props }) => (
  <p className={cn('mt-[7px] text-caption text-danger', className)} {...props} />
);
